<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<div style="height: 100vh;  background: url(/assets/img/private-hotel-pool.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;" class="flex justify-content-center align-items-center">

  <div class="flex-column">
    <div style="width: 450px;" class="p-shadow-2">
      <p-card>
        <div class="p-4">
          <img style="width:300px;height:auto" src="assets/img/logo.png" alt="KBM Resorts Owner Login" /><br><br>
          @if (showResetForm) {
            <div>
              <div>
                <h2 style="color:grey;">Create New Password</h2>
                <p>Enter a new password below:</p><br>
              </div>
              <form [formGroup]="form1">
                <div formGroupName="passwordGroup">
                  <div class="p-fluid grid">
                    <div class="p-field col-12">
                      <span class="p-float-label">
                        <input formControlName="password" id="password" type="password" match="confirmPassword" pPassword>
                        <label for="password">Password</label>
                        @for (validation of validationMessages.password; track validation) {
                          <span>
                            @if (form1.get('passwordGroup.password').hasError(validation.type) && (form1.get('passwordGroup.password').dirty || form1.get('passwordGroup.password').touched)) {
                              <small id="username2-help" class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                      <br>
                        <span class="p-float-label">
                          <input formControlName="confirmPassword" id="confirmPassword" type="password" [feedback]="false" pPassword>
                          <label for="confirmPassword">Confirm Password</label>
                          @for (validation of validationMessages.confirmPassword; track validation) {
                            <span>
                              @if (form1.get('passwordGroup.confirmPassword').hasError(validation.type) && (form1.get('passwordGroup.confirmPassword').dirty || form1.get('passwordGroup.confirmPassword').touched)) {
                                <small id="username2-help" class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                        <div>
                          @if (formErrorMessage) {
                            <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
                          }
                          <br>
                            <button pButton type="button" label="Update Password" (click)="onPasswordUpdateSubmit()"></button><br>
                          </div>
                          <div style="margin-top:100px;">
                            <button pButton type="button" label="Cancel" class="p-button-outlined" [routerLink]="'/login'"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              }
              @if (showResetConfirm) {
                <div>
                  <div>
                    <h2 style="color:grey;">Password Reset</h2>
                    <p><i class="pi pi-check-circle" style="color:green"></i>&nbsp;&nbsp;&nbsp;<b style="color:green">Success</b><br><br>Your password has been successfully changed, please
                    proceed to login to enter your
                  new credentials.</p>
                </div>
                <div class="p-fluid grid">
                  <div class="p-field col-12">
                    <div style="margin-top:100px;">
                      <button pButton type="button" label="Login" [routerLink]="'/login'"></button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </p-card>
      </div>
    </div>
  </div>
